import { useStoreContext } from './useStoreContext'

export const usePrescriptionEnabled = () => {
  const store = useStoreContext()
  return store.prescriptionEnabled
}
